// Routes where an out-of-credits modal would be redundant or unwelcome, so it stays hidden:
//   /  and /new   — the project-creation surfaces already show the full-screen SubscriptionGate
//                   (see RequireCredits), and a modal on top of it would double up.
//   /settings/*   — the Subscription tab (which the modal links to) lives here; don't cover it.
//   /admin/*      — admins are intentionally exempt from the credit gate; never nag them.
export function isSuppressedPath(pathname: string): boolean {
  return (
    pathname === '/' ||
    pathname === '/new' ||
    pathname.startsWith('/settings') ||
    pathname.startsWith('/admin')
  )
}
